import React from 'react';
import AboutProperties from '../AboutProperties/AboutProperties';
import {aboutPropertySelectorFn} from '../../../../../shared/pages/DetailsPage/selectors/index';
import {useSelector} from 'react-redux';

const AboutHotel = () => {
  const aboutPropertyData = useSelector(aboutPropertySelectorFn);
  return (
    <>
      {!!aboutPropertyData && aboutPropertyData.length > 0 && (
        <AboutProperties text={'About Property'} data={aboutPropertyData} />
      )}
    </>
  );
};

export default AboutHotel;
